export const DEFAULT_LOGOUT_TIMEOUT = 1000 * 60 * 25;
export const DEFAULT_WARNING_TIMEOUT = 1000 * 60 * 20;

export const SHOW_WARNING_DIALOG_DURATION =
  DEFAULT_LOGOUT_TIMEOUT - DEFAULT_WARNING_TIMEOUT;

export const SHOW_WARNING_DIALOG_LOCAL_STORAGE_KEY =
  "timeToShowWarningDialogBeforeUserLogout";

export const DELAY_USER_LOGOUT_PROCESS_EVENTS = [
  {
    name: "load",
    capture: false,
  },
  {
    name: "click",
    capture: false,
  },
  {
    name: "keydown",
    capture: false,
  },
  {
    name: "mousemove",
    capture: false,
  },
  {
    name: "scroll",
    capture: true,
  },
];

export const AUTO_LOGOUT_METRIC_DATA = {
  OPEN_DIALOG: "open",
  CLOSE_DIALOG: "close",
  AUTO_LOGOUT: "auto-logout",
  LOGOUT_BUTTON_CLICK: "logout-button_click",
  CANCEL_LOGOUT_BUTTON_CLICK: "cancel-logout-button_click",
};

export const AUTO_LOGOUT_METRIC_NAME = "sb-auto-logout-dialog";
